import { atom, selectorFamily } from "recoil"

interface BlockVisibilityState {
  [key: string]: boolean
}

export const blockVisibilityAtom = atom<BlockVisibilityState>({
  default: {},
  key: "blockVisibilityAtomFamily",
})

export const blockVisibilityState = selectorFamily<boolean, string>({
  key: "blockVisibilityState",
  get:
    (blockId: string) =>
    ({ get }) =>
      get(blockVisibilityAtom)[blockId],
  set:
    (blockId: string) =>
    ({ set }, newValue) =>
      set(blockVisibilityAtom, prevState => {
        return {
          ...prevState,
          [blockId]: newValue,
        } as BlockVisibilityState
      }),
})

export const blocksVisibilityState = selectorFamily<boolean, string[]>({
  key: "blocksVisibilityState",
  get:
    (blockIds: string[]) =>
    ({ get }) => {
      const blockVisibility = get(blockVisibilityAtom)

      return blockIds.some(blockId => blockVisibility[blockId])
    },
})
